import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const ServiceSection = () => {
  const [serviceData, setServiceData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchServiceData = async () => {
      try {
        const response = await fetch(
          "https://ecommerce-product-05-19692c57dcd1.herokuapp.com/api/service-section"
        );
        const result = await response.json();

        if (!result.success) {
          throw new Error(result.message || "Failed to fetch data");
        }

        setServiceData(result.data);
      } catch (err) {
        setError(err.message);
        console.error("Error fetching service section data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchServiceData();
  }, []);

  if (loading) {
    return <></>;
  }

  if (error) {
    return (
      <div id="service" className="best-service section-padding">
        <div className="container">
          <div className="alert alert-danger" role="alert">
            Error loading content: {error}
          </div>
        </div>
      </div>
    );
  }

  if (!serviceData || !serviceData.isActive) {
    return null; // Don't render if section is inactive
  }

  return (
    <div id="service" className="best-service section-padding">
      <div className="container">
        <div className="section-title">
          <h2>{serviceData.sectionTitle}</h2>
          <p>
            {serviceData.sectionDescription.split(".")[0].trim()}.
            <span> {serviceData.sectionDescription.split(".")[1]?.trim()}</span>
          </p>
        </div>
        <div className="row text-center">
          {serviceData.services.map((service) => (
            <div
              key={service.id}
              className="col-lg-3 col-sm-4 col-xs-12 wow fadeInUp"
              data-wow-duration="1s"
              data-wow-delay="0.1s"
              data-wow-offset={0}
            >
              <div className="single_service">
                <div className="ss_icon">
                  <span className={service.iconClass} />
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <Link className="cta-button"></Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceSection;
